import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope,faPhone,faGlobe} from '@fortawesome/free-solid-svg-icons'
import { faYoutube,faInstagram,faFacebook,faLinkedin,faTwitter } from '@fortawesome/free-brands-svg-icons'
import h1 from "./assets/images/JS-footer-logo.png";

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row justify-content-center align-items-center">
        <div className="col-lg-3 col-md-4 col-sm-4">
      <div className="footer-logo">
      <img src={h1} alt="" />
      </div>
          </div>

          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="icon-box">
              <div className="icon" style={{fontSize:'30px',marginRight:'5px'}}>

                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className="icon-text">
                <a href="mailto:RDA@jsbl.com">
                  Email
                  <br />
                  RDA@jsbl.com
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="icon-box">
            <div className="icon" style={{fontSize:'30px',marginRight:'5px'}}>
              <FontAwesomeIcon icon={faPhone} />

              </div>
              <div className="icon-text">
                <a href="tel:111-654-321">
                  Toll Free Number
                  <br />
                  111 654 321
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-4 col-sm-4">
            <div className="icon-box">
            <div className="icon" style={{fontSize:'30px',marginRight:'5px'}}>
                <FontAwesomeIcon icon={faGlobe} />

              </div>
              <div className="icon-text">
                <a href="https://jsbl.com/">
                  Website
                  <br />
                  https://jsbl.com
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-4">
            <div className="icon-text">
              <h6>Follow us on social media</h6>

              <div className="footer-sosil-icon">
                <div className="sosil-icon">
                  <a href="https://www.youtube.com/channel/UCea6Jd1c8n7ZlshmIBT9r7w/featured ">
                  <FontAwesomeIcon icon={faYoutube} color='#fff' />
                  </a>
                
                </div>

                <div className="sosil-icon">
                  <a href="https://www.facebook.com/JSBankLtd">
                  <FontAwesomeIcon icon={faFacebook} color='#fff'/>
                  </a>
                  

                </div>

                <div className="sosil-icon">
                <a href="https://www.instagram.com/jsbankltd/ ">
                <FontAwesomeIcon icon={faInstagram} color='#fff' />

                </a>
                  
                </div>

                <div className="sosil-icon">
                <a href=" https://twitter.com/jsblpak ">
                <FontAwesomeIcon icon={faTwitter} color='#fff' />
                </a>
                  

                </div>

                <div className="sosil-icon">
                <a href="https://www.linkedin.com/company/js-bank/ ">
                <FontAwesomeIcon icon={faLinkedin} color='#fff' />
                </a>
                  

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
